import request from '@/utils/request'

/**
 * 获取用户可领取的优惠券列表
 */
export function getAvailableCoupons() {
    return request({
        url: '/shop/userCoupon/available',
        method: 'get'
    })
}

/**
 * 领取优惠券
 * @param {number} couponId 优惠券ID
 */
export function receiveCoupon(templateId) {
    return request({
        url: '/shop/userCoupon/receive',
        method: 'post',
        data: { templateId }
    })
}

/**
 * 获取“我的”优惠券列表
 * @param {object} params { pageNum, pageSize, status }
 */
export function getMyCoupons(params) {
    return request({
        url: '/shop/userCoupon/myCoupons',
        method: 'get',
        params
    })
}
